import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/embed', name: 'Embed', component: () => import('@/views/Embed.vue') },
  // 分享给客户的文章预览页：/article?faq_document_id=xxx（无需登录）
  { path: '/article', name: 'Article', component: () => import('@/views/Article.vue') }
]

export default new VueRouter({ mode: 'hash', routes })
